export const GET_RECENT_RESOURCES = "GET_RECENT_RESOURCES";
